// extracted by mini-css-extract-plugin
export default {"titleImage":"ForgotPasswordPage_titleImage__1Qd3E","message":"ForgotPasswordPage_message__2zcSb","contactUs":"ForgotPasswordPage_contactUs__7p8I-"};